import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { GenericTryPluginModal } from "./GenericTryPluginModal"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectUserID } from "user/profile/selectors"
import { SampleDataFlightKey } from "@nova/constants"
import { createVideoColorFinderFlight } from "features/pubsub/entityActions/flights/videoColorFinder"
import { hideGlobalModal } from "runlevel/actions"

export const TryColorfinderModal = () => {
    const dispatch = useAppDispatch()
    const userId = useAppSelector(selectUserID)

    const createSampleColorfinderFlight = () => {
        if (!userId) return

        dispatch(
            createVideoColorFinderFlight({
                data: {
                    createdBy: {
                        userId,
                    },
                },
                context: {
                    sampleDataFlightKey: SampleDataFlightKey.vcf2,
                },
            })
        )

        dispatch(hideGlobalModal())
    }

    return (
        <GenericTryPluginModal
            pluginId={NovaPluginIds.Colorfinder}
            title="Try Colorfinder for free"
            subtitle="Find the clues that count."
            body="Enhance your ability to identify clues in your drone footage when it matters most. Detect color anomalies invisible to the human eye and focus your search efforts where it matters most."
            footer="Use pre-loaded sample data to experience this powerful tool."
            buttonTitle="Use Sample Data"
            onButtonClick={createSampleColorfinderFlight}
        />
    )
}
